import { ReactElement } from 'react'
import { Flexbox } from '../flexbox/flexbox'
import { useIntl } from 'react-intl'
import { RiDashboardFill, RiLogoutBoxFill } from 'react-icons/ri'
import { MdAdminPanelSettings } from 'react-icons/md'
import { BsFillGearFill } from 'react-icons/bs'
import { FaTools } from 'react-icons/fa'
import './app-navigation.css'
import { useLogout } from '../../utils/use-logout'
import AppNavigationGroup from './app-navigation-group'
import AppNavigationItem from './app-navigation-item'
import { ACLContainer } from '../acl-container/acl-container'

const ICON_SIZE = 24

const AppNavigation = (): ReactElement => {
  const { formatMessage } = useIntl()

  const logout = useLogout()

  return (
    <Flexbox flex={1} className="app-navigation p-4">
      <Flexbox flex={1} isCol>
        <div className="font-bold text-2xl p-2">1101 Capital</div>
        <div>
          <div>
            <AppNavigationItem
              to={'/dashboard'}
              icon={<RiDashboardFill size={ICON_SIZE} />}
              title={formatMessage({
                id: 'navigation-dashboard',
                defaultMessage: 'Dashboard',
              })}
            />
            <ACLContainer onlyManagement>
              <AppNavigationGroup
                pathRoot="manager"
                icon={<MdAdminPanelSettings size={ICON_SIZE} className="app-navigation__icon" />}
                title={formatMessage({
                  id: 'navigation-manager',
                  defaultMessage: 'Manager',
                })}>
                <AppNavigationItem to="/manager/accounts" title="Accounts" />
                <AppNavigationItem to="/manager/deposits" title="Deposits" />
                <AppNavigationItem to="/manager/withdrawals" title="Withdrawals" />
                <AppNavigationItem to="/manager/profits" title="Profits" />
                <AppNavigationItem to="/manager/bank-connect" title="Bank Connect" />
              </AppNavigationGroup>
            </ACLContainer>
            <AppNavigationGroup
              pathRoot="settings"
              icon={<BsFillGearFill size={ICON_SIZE} />}
              title={formatMessage({
                id: 'navigation-settings',
                defaultMessage: 'Settings',
              })}>
              <AppNavigationItem
                to="/settings/profile"
                title={formatMessage({
                  id: 'navigation-profile-profile',
                  defaultMessage: 'Profile',
                })}
              />
              <AppNavigationItem
                to="/settings/security"
                title={formatMessage({
                  id: 'navigation-profile-security',
                  defaultMessage: 'Security',
                })}
              />
            </AppNavigationGroup>
            <ACLContainer onlyManagement>
              <AppNavigationGroup
                pathRoot="tools"
                title="Tools"
                icon={<FaTools size={ICON_SIZE} />}>
                <AppNavigationItem to="tools/investing-cycle" title="Investing Cycle" />
              </AppNavigationGroup>
            </ACLContainer>
            <ACLContainer onlyAdmin>
              <AppNavigationGroup
                pathRoot="admin"
                icon={<MdAdminPanelSettings size={ICON_SIZE} className="app-navigation__icon" />}
                title={formatMessage({
                  id: 'navigation-admin',
                  defaultMessage: 'Admin',
                })}>
                <ACLContainer onlyAdmin>
                  <AppNavigationItem to="/admin/access-roles" title="Access Roles" />
                  <AppNavigationItem to="/admin/currencies" title="Currencies" />
                </ACLContainer>
                <AppNavigationItem to="/admin/users" title="Users" />
              </AppNavigationGroup>
            </ACLContainer>
            <AppNavigationItem
              onPress={logout}
              to="/"
              isExactPath
              icon={<RiLogoutBoxFill size={ICON_SIZE} />}
              title={formatMessage({
                id: 'navigation-logout',
                defaultMessage: 'Logout',
              })}
            />
          </div>
        </div>
      </Flexbox>
    </Flexbox>
  )
}

export default AppNavigation